import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const pdfApi = createApi({
  reducerPath: "pdfApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/pdfs/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getTags: builder.query({
      query: () => ({
        url: "tags",
        method: "GET",
      }),
      // providesTags: (result) => [
      //   { type: "Pdf-Tag", id: "List" },
      //   ...(result ?? []).map((Tag) => ({ type: "Pdf-Tag", id: Tag.id })),
      // ],
    }),
    getPdfWithTags: builder.query({
      query: ({ type, Id }) => ({
        
        url: `get-pdfs-with-tags?tagType=${type}&entityId=${Id}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Pdf-Tag", id: "List" },
        ...(result ?? []).map((PDF) => ({ type: "Pdf-Tag", id: PDF.id })),
      ],
    }),
    getAllPdfs: builder.query({
      query: () => ({
        url: "get-all-pdfs",
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Pdf-Tag", id: "List" },
        ...(result ?? []).map((Tag) => ({ type: "Pdf-Tag", id: Tag.id })),
      ],
    }),
    addTagsToPdf: builder.mutation({
      query: ({ pdfId, formData }) => ({
        url: `${pdfId}/tags`,
        body: formData,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Pdf-Tag", id: "List" },
        { type: "Pdf-Tag", id: (id) => id },
      ],
    }),
    createPdfWithTags: builder.mutation({
      query: (data) => ({
        url: "create-pdf-with-tags",
        body: data,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Pdf-Tag", id: "List" },
        { type: "Pdf-Tag", id: (id) => id },
      ],
    }),
    removeTagFromPdf: builder.mutation({
      query: ({ tagId, pdfId }) => ({
        url: `delete-tag-from-pdf/${pdfId}/${tagId}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Pdf-Tag", id: "List" },
        { type: "Pdf-Tag", id: (id) => id },
      ],
    }),

    deletePdf: builder.mutation({
      query: (id) => ({
        url: `delete-pdf/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Pdf-Tag", id: "List" },
        { type: "Pdf-Tag", id: (id) => id },
      ],
    }),
  }),
});

export const {
  useGetTagsQuery,
  useCreatePdfWithTagsMutation,
  useGetPdfWithTagsQuery,
  useDeletePdfMutation,
  useAddTagsToPdfMutation,
  useRemoveTagFromPdfMutation,
  useGetAllPdfsQuery,
} = pdfApi;
